import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ObtenerNumeroAgentesSqlService {
  private readonly agentesSqlUrl: string;

  constructor(private httpClient: HttpClient) {
    this.agentesSqlUrl = environment.apiUrl + '/administrador/agentes/sql/total';
  }

  public __invoke(): Observable<number> {
    return this.httpClient.get<number>(this.agentesSqlUrl);
  }
}
